import { registerAudienceLifecycle } from '@/features/audience'
import { registerCommerceLifecycle } from '@/features/commerce-analytics'
import { registerCreativeAiLifecycle } from '@/features/creative-ai'
import { registerCreditsLifecycle } from '@/features/credits'
import { registerGlobalSurfaceLifecycle } from '@/features/global-surface'
import { registerHealthChecksLifecycle } from '@/features/health-checks'
import { registerImpactLifecycle } from '@/features/impact-analysis'
import { registerMarketingInsightsLifecycle } from '@/features/marketing-insights'

/**
 * The per-feature workspace/session reset owners (ORP-22678), installed once from the boot
 * sequence in the same alphabetical position their siblings occupy there.
 *
 * They live in this file rather than inline in `bootstrap.ts` for one reason only: eight more
 * barrel imports and eight more calls put the composition root over the 400-line budget
 * (BRIEF §4.4). Nothing else moves — `registerAlertsLifecycle`, `registerAnomalySessionReset`
 * and the rest still register from `bootstrap.ts`, and this is called from the same block.
 *
 * Each module decides for its own stores what a workspace switch wipes versus what only a
 * session reset clears (contracts 06 §7, 07 §7–§8); the reasoning lives next to the stores it
 * concerns, not here. `scripts/check-store-lifecycle.mjs` fails the build if a feature store
 * has no such owner.
 */
export function registerFeatureLifecycles(): void {
  registerAudienceLifecycle()
  registerCommerceLifecycle()
  registerCreativeAiLifecycle()
  registerCreditsLifecycle()
  registerGlobalSurfaceLifecycle()
  registerHealthChecksLifecycle()
  registerImpactLifecycle()
  registerMarketingInsightsLifecycle()
}
